export const convertToCSVString = (objArray: any[], delimiter: ',' | ';'): string => {
  if (!Array.isArray(objArray) || objArray.length === 0) {
    throw new Error('Input must be a non-empty array of objects.');
  }

  const keys = Object.keys(objArray[0]);
  const header = keys.join(delimiter);

  const rows = objArray.map((obj) =>
    keys.map((key) => (obj[key] != null ? obj[key] : '')).join(delimiter)
  );

  return [header, ...rows].join('\r\n');
};

const convertCsvToJson = (csv: string, delimeter: string) => {
  const [header] = csv.split('\n');
  const keys = header.split(delimeter);

  const jsonResult = keys.reduce((acc: any, key: any) => {
    acc[key] = null; // Assigning null as placeholder value for each key
    return acc;
  }, {});

  return [jsonResult];
};

export const generateTemplateCsv = (csvHeaders: string, delimeter: ',' | ';') => {
  const jsonObject = convertCsvToJson(csvHeaders, delimeter);

  return convertToCSVString(jsonObject, delimeter);
};

export type FileName = `${string}.${string}`;

export const downloadBlobAsFile = (blob: Blob, fileName: FileName) => {
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const downloadTemplateCsv = (
  csvHeaders: string,
  fileName: FileName,
  delimeter: ',' | ';' = ';'
) => {
  const csvContent = generateTemplateCsv(csvHeaders, delimeter);

  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });

  downloadBlobAsFile(blob, fileName);
};

export type CsvCellContent = string | number | boolean | Date | null | undefined;

interface DownloadCsvProps {
  headers: string[];
  rows: CsvCellContent[][];
  fileName: FileName;
  delimeter?: ',' | ';';
}

export const downloadAsCsv = ({ headers, rows, fileName, delimeter }: DownloadCsvProps) => {
  const csvContent = getCsvData([headers, ...rows], delimeter);

  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });

  downloadBlobAsFile(blob, fileName);
};

export const getCsvData = (data: CsvCellContent[][], delimeter: ',' | ';' = ';'): string => {
  return data
    .map((row) =>
      row
        .map((value) => {
          if (value === null || value === undefined) return '';

          if (value instanceof Date) {
            const year = value.getFullYear();
            const month = String(value.getMonth() + 1).padStart(2, '0');
            const day = String(value.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
          }

          if (Number(value)) {
            return `="${String(value).replace('.', ',')}"`;
          }

          const str = String(value);

          if (str.includes(',') || str.includes(delimeter)) {
            return `"${str.replace(/"/g, '""')}"`;
          }

          return str;
        })
        .join(delimeter)
    )
    .join('\n');
};
